import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { orderApi } from '#services/order';
import { revertAll } from '../actions';

interface OrderListForUserDetailState {
  filter: string;
  filterKey: string;
  headerFilters: Record<string, Record<string, boolean>>;
  order: string;
  orderBy: string;
  pageIndex: number;
  pageSize: number;
  rows: unknown[];
  rowCount: number;
  selected: Array<string | number | undefined>;
}

const initialState: OrderListForUserDetailState = {
  filter: '',
  filterKey: 'orderId',
  headerFilters: {},
  order: 'desc',
  orderBy: 'id',
  pageIndex: 0,
  pageSize: 30,
  rows: [],
  rowCount: 0,
  selected: [],
};

export const orderListForUserDetailSlice = createSlice({
  name: 'orderListForUserDetail',
  initialState,
  reducers: {
    setFilter(state, action: PayloadAction<string>) {
      state.filter = action.payload;
      state.pageIndex = 0;
    },
    setFilterKey(state, action: PayloadAction<string>) {
      state.filterKey = action.payload;
    },
    setHeaderFilters(state, action: PayloadAction<Record<string, Record<string, boolean>>>) {
      state.headerFilters = action.payload;
    },
    setOrder(state, action: PayloadAction<string>) {
      state.order = action.payload;
    },
    setOrderBy(state, action: PayloadAction<string>) {
      state.orderBy = action.payload;
    },
    setPageIndex(state, action: PayloadAction<number>) {
      state.pageIndex = action.payload;
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload;
      state.pageIndex = 0;
    },
    setRows(state, action: PayloadAction<unknown[]>) {
      state.rows = action.payload;
    },
    setRowCount(state, action: PayloadAction<number>) {
      state.rowCount = action.payload;
    },
    setSelected(state, action: PayloadAction<Array<string | number | undefined>>) {
      const { payload } = action;
      state.selected = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(revertAll, () => initialState)
      .addMatcher(orderApi.endpoints.getOrders.matchFulfilled, (state, action) => {
        const { page, rows, total } = action.payload as {
          page: number;
          rows: unknown[];
          total: number;
        };
        state.rows = rows;
        state.rowCount = total;
        state.pageIndex = page;
        // dont clear the selected data,
        // the selected states should be remembered for the crossing page selection
        // state.selected = [];
      });
  },
});

export const {
  setFilter,
  setFilterKey,
  setPageSize,
  setHeaderFilters,
  setOrder,
  setOrderBy,
  setPageIndex,
  setRows,
  setRowCount,
  setSelected,
} = orderListForUserDetailSlice.actions;

export default orderListForUserDetailSlice.reducer;
